import { InvestorDetailsGetInvestorLegalEntitiesQuery } from '@/__generated__/graphql';
import { ISelectValue } from '@/components/basicComponents/select';
import { ITab } from '@/components/basicComponents/tabs';
import { PaddingWrap } from '@/styles/common';
import { InvestorDetailsLayout } from '../../investorDetailsLayout';
import { InvestorDetailsEntityTypeEnum } from '../../types';
import ActivityTable from './table/table';

interface ActivityTabProps {
  entityType: InvestorDetailsEntityTypeEnum;
  investorData: {
    investorName: string;
    advisorName: string;
    legalEntities: InvestorDetailsGetInvestorLegalEntitiesQuery['getInvestor']['legalEntities'];
    legalEntitiesTotalCount: number;
  };
  selectedGroupName: string;
  entitiesSelectOptions: ISelectValue[];
  entityIdsForActivityTab: string[];
  tabs: ITab[];
  resetEntityType: () => void;
}

export const ActivityTab = ({
  entityType,
  investorData,
  selectedGroupName,
  entitiesSelectOptions,
  entityIdsForActivityTab,
  tabs,
  resetEntityType
}: ActivityTabProps) => {
  return (
    <InvestorDetailsLayout
      entityType={entityType}
      investorData={investorData}
      selectedGroupName={selectedGroupName}
      entitiesSelectOptions={entitiesSelectOptions}
      tabs={tabs}
      resetEntityType={resetEntityType}
    >
      <PaddingWrap>
        <ActivityTable entityType={entityType} entityIdsForActivityTab={entityIdsForActivityTab} />
      </PaddingWrap>
    </InvestorDetailsLayout>
  );
};
